import React, { Fragment } from 'react';
import Header from '../../components/header/Header';
import caseStudies from "../../api/case";
import { Link, useParams } from 'react-router-dom';
import Scrollbar from '../../components/scrollbar/scrollbar'
import CtaSection from '../../components/CtaSection/CtaSection';
import Footer from '../../components/footer/Footer';
import Bg from '../../images/bg/page_bg01.jpg'
import icon from '../../images/icon/eye-icon.svg'
import caseImg from '../../images/service/1.png'
import cIcon1 from '../../images/icon/csd-icon01.svg'
import cIcon2 from '../../images/icon/csd-icon02.svg'
import cIcon3 from '../../images/icon/csd-icon03.svg'
import cIcon4 from '../../images/icon/csd-icon04.svg'
import cIcon from '../../images/icon/check-icon.svg'


const CaseStudySingle = (props) => {
    const { slug } = useParams()

    const CaseDetails = caseStudies.find(item => item.slug === slug)

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <Fragment>
            <div className='body_wrap sco_agency'>
                <Header />

                {/* PAGE HEADER */}
                <section className="page-title pt-200 pos-rel bg_img" style={{ backgroundImage: `url(${Bg})` }}>
                    <div className="container">
                        <div className="page-title-wrap">
                            <div className="row mt-none-30 align-items-end">

                                <div className="col-lg-9 mt-30">
                                    <div className="page-title-box">
                                        <span className="sub-title"><img src={icon} alt="" /> {CaseDetails.title}</span>

                                        {/* DYNAMIC TITLE BASED ON CASE */}
                                        <h2 className="title">
                                            {CaseDetails.mainTitle}
                                        </h2>
                                    </div>
                                </div>

                                <div className="col-lg-3 mt-30">
                                    <div className="count-box">
                                        <h2 className="number">10<span className="suffix">+</span></h2>
                                        <span className="text">our most popular <br /> casestudy</span>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>

                {/* MAIN IMAGE */}
                <div className="csd-img pt-70 pb-65">
                    <div className="container">
                        <div className="item-details_image pos-rel">
                            <img src={caseImg} alt="" />
                        </div>
                    </div>
                </div>

                {/* CASE DESCRIPTION */}
                <div className="sd-ser-content_wrap pb-90">
                    <div className="container">
                        <div className="sd-ser-content">

                            {/* UPDATED HEADING */}
                            <h2 className="sd-title">{CaseDetails.mainTitle}</h2>

                            {/* UPDATED PARAGRAPH 1 */}
                            <p className="sd-content">
                                <span style={{fontWeight: 'bold'}}>Challenge:</span> {CaseDetails.challenge}
                            </p>
                            <br />

                            {/* UPDATED PARAGRAPH 2 */}
                            <p className="sd-content">
                                <span style={{fontWeight: 'bold'}}>Approach:</span> {CaseDetails.approach}
                            </p>

                        </div>
                    </div>
                </div>

                {/* CASE DETAILS ROW */}
                <div className="csd-ser_warp">
                    <div className="container">
                        <div className="csd-ser_inner ul_li_between">

                            {/* UPDATED CONTENT */}
                            <div className="csd-item ul_li">
                                <div className="xb-icon"><img src={cIcon1} alt="" /></div>
                                <h6 className="xb-text">client : <span>{CaseDetails.client}</span></h6>
                            </div>

                            <div className="csd-item ul_li">
                                <div className="xb-icon"><img src={cIcon2} alt="" /></div>
                                <h6 className="xb-text">services : <span>{CaseDetails.service}</span></h6>
                            </div>

                            <div className="csd-item ul_li">
                                <div className="xb-icon"><img src={cIcon3} alt="" /></div>
                                <h6 className="xb-text">completed date : <span>{CaseDetails.date}</span></h6>
                            </div>

                            <div className="csd-item ul_li">
                                <div className="xb-icon"><img src={cIcon4} alt="" /></div>
                                <h6 className="xb-text">location : <span>{CaseDetails.location}</span></h6>
                            </div>

                        </div>
                    </div>
                </div>

                {/* REQUIREMENTS SECTION */}
                <div className="sd-service_wrap pt-90 pb-130">
                    <div className="container">
                        <div className="sd-ser-outcome">

                            <div className="sd-heading">
                                <h2 className="sd-title">Project requirement</h2>

                                {/* UPDATED CONTENT */}
                                <p className="sd-content">
                                    {CaseDetails.challenge}
                                </p>
                            </div>

                            <div className="sd-list-item ul_li">
                                <ul className="sd-ser-list list-unstyled">

                                    {/* UPDATED LIST */}
                                    {CaseDetails.requirements.slice(0, 4).map((req, index) => (
                                        <li key={index}><img src={cIcon} alt="" />{req}</li>
                                    ))}

                                </ul>

                                <ul className="sd-ser-list list-unstyled">

                                    {CaseDetails.requirements.slice(4, 8).map((req, index) => (
                                        <li key={index}><img src={cIcon} alt="" />{req}</li>
                                    ))}

                                </ul>
                            </div>

                        </div>

                        {/* SOLUTION & RESULT */}
                        <div className="sd-heading csd-heading pt-90">
                            <h2 className="sd-title">Solution & result</h2>

                            {/* UPDATED SOLUTION */}
                            <p className="sd-content">
                                <span style={{fontWeight: 'bold'}}>Solution:</span> {CaseDetails.approach}
                            </p>
                            <br />

                            {/* UPDATED RESULT */}
                            <p className="sd-content">
                                <span style={{fontWeight: 'bold'}}>Result:</span> {CaseDetails.result}
                            </p>
                        </div>

                        {/* SIMILAR CASES */}
                        <div className="similar-casestudy pt-80">
                            <h2 className="similar-casestudy-title">Key outcomes & achievements</h2>

                            <div className="sd-list-item ul_li">
                                <ul className="sd-ser-list list-unstyled">
                                    {CaseDetails.outcomes.slice(0, 3).map((outcome, index) => (
                                        <li key={index}><img src={cIcon} alt="" />{outcome}</li>
                                    ))}
                                </ul>

                                <ul className="sd-ser-list list-unstyled">
                                    {CaseDetails.outcomes.slice(3, 6).map((outcome, index) => (
                                        <li key={index}><img src={cIcon} alt="" />{outcome}</li>
                                    ))}
                                </ul>
                            </div>

                            <h2 className="similar-casestudy-title mt-5">Our similar casestudy</h2>

                            <div className="row mt-none-30">
                                {caseStudies.slice(3, 6).map((cases, citem) => (
                                    <div className="col-lg-4 col-md-6 mt-30" key={citem}>
                                        <div className="casestudy-item">
                                            <div className="casestudy-img">
                                                <Link onClick={ClickHandler} to={`/casestudy-details/${cases.slug}`}>
                                                    <img src={cases.img} alt="" />
                                                </Link>
                                                <div className="content_wrap">
                                                    <h3 className="item_title">{cases.title}</h3>
                                                    <span className="item_tag">{cases.slug}</span>
                                                </div>
                                            </div>
                                            <Link onClick={ClickHandler} to={`/casestudy-details/${cases.slug}`} className="xb-overlay"></Link>
                                        </div>
                                    </div>
                                ))}
                            </div>

                        </div>
                    </div>
                </div>

                <CtaSection />
            </div>

            <Footer />
            <Scrollbar />
        </Fragment>
    )
};

export default CaseStudySingle;
